import { cloneDeep } from 'lodash';
import type { TemplateDropdownType } from '@app/template/TemplateDropdown';
import { TEMPLATE_ROLE_PRIORITY_MAP } from '@bb/domain/dist/types';

// 1.user default 2.team default 3.branch default 4.global default, 5. last edited
const sortTemplates = (initialTemplates: TemplateDropdownType) => {
  // Cloning is unnecessary as the used place does it in the first place,
  // but cannot rely on outside scope action.
  const templates = cloneDeep(initialTemplates);

  return templates.sort((a, b) => {
    let diff = 0;
    if (a.isDefault || b.isDefault) {
      diff += !a.isDefault ? -8 : !b.isDefault ? 8 : 0;
      diff +=
        TEMPLATE_ROLE_PRIORITY_MAP[a.role] > TEMPLATE_ROLE_PRIORITY_MAP[b.role]
          ? -4
          : TEMPLATE_ROLE_PRIORITY_MAP[a.role] <
              TEMPLATE_ROLE_PRIORITY_MAP[b.role]
            ? 4
            : 0;
      diff += b.name.localeCompare(a.name) > 0 ? 2 : -2;
    }
    // No updatedAt means a root default added by our FE system, and it will be a default.
    // Therefore, no need for updatedAt check if that is the case.
    if (a.updatedAt && b.updatedAt) {
      diff +=
        a.updatedAt > b.updatedAt ? 1 : a.updatedAt < b.updatedAt ? -1 : 0;
    }
    return -diff; // descending order
  });
};

export default sortTemplates;
